import React from "react";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import FormHelperText from "@mui/material/FormHelperText";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";

import PeopleIcon from "@mui/icons-material/People";
import EmailIcon from "@mui/icons-material/Email";
import ChatIcon from "@mui/icons-material/Chat";
import DnsIcon from "@mui/icons-material/Dns";
import { Box } from "@mui/material";
import { useThemeMode } from "../../contexts/ThemeModeContext";

type Props = {
  formData: any;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
};

export const StepIntegrations: React.FC<Props> = ({
  formData,
  setFormData,
}) => {
  const [error, setError] = React.useState("");
  const { mode } = useThemeMode();

  const integrationButtons = [
    { label: "Connect to Teams", icon: <PeopleIcon /> },
    { label: "Connect to Slack", icon: <ChatIcon /> },
    { label: "Connect to Emails", icon: <EmailIcon /> },
    { label: "Connect to CRM (Salesforce)", icon: <DnsIcon /> },
  ];

  const handleCheckboxChange = (checked: boolean) => {
    setFormData((prev: any) => ({
      ...prev,
      acceptTerms: checked,
    }));

    if (checked) setError("");
  };

  return (
    <div className="space-y-6">
      <Typography variant="h5" sx={{ mt: 3, mb: 3 }}>
        5. Integrations & Finalization
      </Typography>

      <Box
        sx={{
          p: 3,
          borderRadius: "20px",
          border:
            mode === "dark"
              ? "1px solid #374151"
              : "1px solid #e5e7eb",
        }}
      >
        <Typography variant="h6" sx={{ mb: 2 }}>
          Integration Setup (Optional)
        </Typography>

        <Grid container spacing={2}>
          {integrationButtons.map((btn) => (
            <Grid item xs={12} sm={6} key={btn.label}>
              <Button
                variant="outlined"
                fullWidth
                startIcon={btn.icon}
                className="!justify-start"
              >
                {btn.label}
              </Button>
            </Grid>
          ))}
        </Grid>

        {/* Legal */}
        <div className="p-4 mt-6 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
          <Typography variant="subtitle1" sx={{ mt: 3 }}>
            Legal Agreement
          </Typography>

          <ul className="list-disc list-inside text-sm text-gray-600 ml-4">
            <li>I confirm all information is accurate and complete.</li>
            <li>I agree to the terms and privacy policy.</li>
            <li>I authorize CoreSupport to process the submitted data.</li>
          </ul>

          <Stack sx={{ mt: 2 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.acceptTerms}
                  onChange={(e) =>
                    handleCheckboxChange(e.target.checked)
                  }
                />
              }
              label="I accept the Terms and Conditions"
            />

            {error && (
              <FormHelperText error sx={{ ml: 4 }}>
                {error}
              </FormHelperText>
            )}
          </Stack>
        </div>
      </Box>
    </div>
  );
};